<app-notification-layout
  [desktopImageSrc]="'/Icono-error-validacion.png'"
  [mobileImageSrc]="'/Icono-error-validacion.png'"
  [title]="'Algo no cuadra...'"
>
  <div class="flex-1 flex flex-col gap-1 justify-even items-center mt-10">
    <p class="p-8 text-xl flex justify-center text-center">
      Tus datos no pasaron la validación. Tienes {{ 3 - attemps }} intentos,
      inténtalo otra vez, que aquí seguimos.
    </p>
    <div class="flex gap-4 p-8">
      <button
        routerLink=""
        class="bg-white w-[169px] h-[51px] text-[15px] uppercase text-red-500 border rounded-full p-4 font-extrabold text-xl mt-10"
      >
        Cancelar
      </button>
      <button
        routerLink="/activate-form"
        class="bg-red-500 w-[169px] h-[51px] text-[15px] uppercase text-white rounded-full p-4 font-extrabold text-xl mt-10"
      >
        Reintentar
      </button>
    </div>
  </div>
</app-notification-layout>
